var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTailoredFinanceOptions24 = function SvgTailoredFinanceOptions24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.112 21.167v.404a.42.42 0 0 0 .132.303.46.46 0 0 0 .317.126h.991a.459.459 0 0 0 .317-.125.418.418 0 0 0 .131-.302v-3.648a.48.48 0 0 0-.139-.334 2.19 2.19 0 0 0-.858-.518c-.146-.05-.3-.074-.455-.073h-5.096a1.401 1.401 0 0 0-.455.073 2.19 2.19 0 0 0-.858.518.48.48 0 0 0-.139.334v3.648c0 .113.047.222.131.302a.46.46 0 0 0 .317.125h.99a.46.46 0 0 0 .318-.126.42.42 0 0 0 .132-.303v-.404h4.224Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19h2m4 0h1",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16s-.097-1.092-.73-1.793a.616.616 0 0 0-.454-.207h-3.632a.606.606 0 0 0-.454.207C12.095 14.906 12 16 12 16m-1.692 0H12h-2 .308Zm8.846 0H20h-1 .154ZM14 3h1.623c.18 0 .36.03.527.088.168.058.32.144.448.251.127.108.229.236.298.376a1 1 0 0 1 .104.443V11M7 16H5.268a1.32 1.32 0 0 1-.897-.345 1.134 1.134 0 0 1-.371-.83V4.176c0-.312.134-.611.371-.832.238-.22.56-.344.897-.344H6m7.153-1H7.847C7.379 2 7 2.36 7 2.804v1.392c0 .444.38.804.847.804h5.306c.468 0 .847-.36.847-.804V2.804C14 2.36 13.62 2 13.153 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8H9m3 3H9M7.15 8H7m.15 3H7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTailoredFinanceOptions24;